import React from "react";
import defaultIconSettings from "./defaultIconSettings";

const CleaningIcon = ({
    color = defaultIconSettings.color,
    size = defaultIconSettings.size,
    className = defaultIconSettings.className,
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            style={{ height: size, width: size }}
            className={className}
        >
            <path
                fill={color}
                d="M96 32v96h128V32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zm0 128c-53 0-96 43-96 96v208c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 256c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L320 64l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L352 64l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6zm76.4 45.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 64l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6s-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6s-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128l-12.4-29.8C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
            />
        </svg>
    );
};

export default CleaningIcon;
